import AuthorisersSummaryRoleComponentSelector from "Dashboard/components/Authorisers/AuthorisersSummaryRoleComponentSelector.vue";
import ClientsSummaryRoleComponentSelector from "Dashboard/components/Clients/ClientsSummaryRoleComponentSelector.vue";
import ContactsSummaryRoleComponentSelector from "Dashboard/components/Contacts/ContactsSummaryRoleComponentSelector.vue";
import ContractorsSummaryRoleComponentSelector from "Dashboard/components/Contractors/ContractorsSummaryRoleComponentSelector.vue";
import ContractsSummaryRoleComponentSelector from "Dashboard/components/Contracts/ContractsSummaryRoleComponentSelector.vue";
import CreateContact from "Dashboard/components/Contacts/CreateContact/Index.vue";
import OnceButton from "@/components/OnceButton.vue";
// import TimesheetDetail from "@/dashboard/components/Timesheets/TimesheetDetail.vue";
import TimesheetsSummaryRoleComponentSelector from "Dashboard/components/Timesheets/TimesheetsSummaryRoleComponentSelector.vue";
import Vue from "vue";

export function registerGlobalComponents() {
  Vue.component("OnceButton", OnceButton);

  Vue.component("AuthorisersSummaryRoleComponentSelector", AuthorisersSummaryRoleComponentSelector);
  Vue.component("ClientsSummaryRoleComponentSelector", ClientsSummaryRoleComponentSelector);
  Vue.component("ContactsSummaryRoleComponentSelector", ContactsSummaryRoleComponentSelector);
  Vue.component("ContractsSummaryRoleComponentSelector", ContractsSummaryRoleComponentSelector);
  Vue.component("ContractorsSummaryRoleComponentSelector", ContractorsSummaryRoleComponentSelector);
  Vue.component("TimesheetsSummaryRoleComponentSelector", TimesheetsSummaryRoleComponentSelector);
  Vue.component("CreateContact", CreateContact);

  // Vue.component("TimesheetDetail", TimesheetDetail);
}
